var map = {
	"./add-icon.svg": "4ba4",
	"./dashboard.svg": "f782",
	"./delete-icon.svg": "43f1",
	"./editor-icon.svg": "e9e4",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./link.svg": "18f0",
	"./lower-add.svg": "fe40",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./phon.svg": "e7cd",
	"./query-icon.svg": "f050",
	"./table.svg": "47f1",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";